import React, { useEffect, useRef } from 'react';
import CompareTableCell from '../compareTableCell/CompareTableCell';
import { combineClassNames } from 'core/css';
import { SvgIcon } from '../../../../core/icons';
import { useTranslate } from '../../../../core/translate';
import { withNotifications } from '../../notifications/NotificationsContext';

const CompareRow = ({
  className,
  feature,
  onFeatureModalOpen,
  staticTable,
  analyticsKey,
  rowIndex,
  notifications,
  disclosure,
  scroll,
  onScroll,
}) => {
  const infoAnalyticsKey = analyticsKey + ':' + feature.description;
  const translate = useTranslate();
  const { show } = notifications;
  const ref = useRef();

  const onOpenDisclosure = (event) => {
    event.preventDefault();
    show(disclosure, event, null, true);
  };

  useEffect(() => {
    if (scroll) {
      scroll(ref);
      onScroll && onScroll();
    }
  }, [scroll]);

  return (
    <tr
      ref={ref}
      className={combineClassNames('compare-row', className)}
      aira-rowindex={rowIndex}>
      <th className="compare-row--description-cell" scope="row">
        {feature.disclosure ? (
          <button
            className="compare-row__disclosure"
            onClick={onOpenDisclosure}
            aria-label={`${feature.description} ${translate(
              'common.disclosure.v3'
            )}`}>
            <span id="featureDesc">{feature.description}</span>
            <span className="compare-row__disclaimer-dagger">†</span>
          </button>
        ) : (
          <span
            id={`featureDesc--${rowIndex}`}
            dangerouslySetInnerHTML={{ __html: feature.description }}
          />
        )}
        {feature.details && (
          <button
            className="compare-row__info-btn stat-image-link"
            onClick={() => onFeatureModalOpen(feature)}
            data-dtm={infoAnalyticsKey}
            aria-label={`Read the ${feature.description} details`}>
            <SvgIcon
              name="info"
              className="compare-row--description-cell__icon svg-icon--primary "
            />
          </button>
        )}
      </th>
      <>
        {feature.values.map(({ columnOption, features }, i) => (
          <td
            className={combineClassNames(
              'compare-row--value-cell',
              columnOption.isSorted ? 'compare-row--value-cell--sorted' : ''
            )}
            key={i}>
            <CompareTableCell
              key={i}
              features={features}
              columnOption={columnOption}
              staticTable={staticTable}></CompareTableCell>
          </td>
        ))}
      </>
    </tr>
  );
};

export default withNotifications(CompareRow);
